// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
      	suggestionMobileStyle: 'style2'
    }
}; 

// Override Settings
(function () {  // Add this
	BoostPFS.inject(this);  // Add this

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {  
	};
  
    if(boostPFSConfig.settings.search.enableSuggestion){
      jQ('.search input[type="submit"]').click(function(e) {
        if (Utils.isMobile() && !jQ(this).parents('.header-search-form').hasClass('active')) {
          e.stopPropagation();
          e.preventDefault();

          jQ(this).parents('.header-search-form').toggleClass('active');
          jQ(this).parents('.header__inner').toggleClass('search-active');
        }
      });
    }   

  
    var instantSearchInit = InstantSearch.prototype.init;

    InstantSearch.prototype.init = function() {  
      jQ('input[name="' + Settings.getSettingValue('search.termKey') + '"]').each(function(i) {
        if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
          var clone = jQ(this).clone();
          jQ(this).replaceWith(clone);
        }
      });

      instantSearchInit.call(this);
    }    
  
    /* var bindEvents = InstantSearchMobile.prototype.bindEvents;
  
    InstantSearchMobile.prototype.bindEvents = function() {
        bindEvents.call(this);

        var self = this;

        jQ('.search input[type="submit"]').off('click').click(function(e) {
          e.stopPropagation();
          e.preventDefault();
          self.openSuggestionMobile()
        });
    }  

	if(boostPFSConfig.settings.search.enableSuggestion){
      jQ('.search input[type="submit"]').click(function(e) {
        e.stopPropagation();
        e.preventDefault();
      });
    } */

})();  // Add this at the end